var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdgeBrowser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79px",
    height: "78px",
    viewBox: "0 0 79 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edge-browser-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.0324886%",
    x2: "100.069867%",
    y2: "50.0324886%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "54.3770644%",
    cy: "50%",
    fx: "54.3770644%",
    fy: "50%",
    r: "60.4683241%",
    gradientTransform: "translate(0.543771,0.500000),scale(0.863271,1.000000),rotate(-9.797644),translate(-0.543771,-0.500000)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.5,
    offset: "85.8045501%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "76.6704311%",
    y1: "24.78208%",
    x2: "33.2424331%",
    y2: "83.1522995%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1595DF",
    offset: "20%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0680D7",
    offset: "70%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "39.374058%",
    cy: "67.8750616%",
    fx: "39.374058%",
    fy: "67.8750616%",
    r: "70.9477684%",
    gradientTransform: "translate(0.393741,0.678751),scale(1.000000,0.810857),rotate(-78.184481),translate(-0.393741,-0.678751)",
    id: "radialGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.5,
    offset: "84.3581386%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "21.2376597%",
    cy: "14.0304311%",
    fx: "21.2376597%",
    fy: "14.0304311%",
    r: "185.650039%",
    gradientTransform: "translate(0.212377,0.140304),scale(0.665475,1.000000),rotate(57.255112),translate(-0.212377,-0.140304)",
    id: "radialGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C1ED",
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FC2DF",
    offset: "20%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC3D2",
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36C752",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "93.7705355%",
    cy: "45.3726388%",
    fx: "93.7705355%",
    fy: "45.3726388%",
    r: "57.112002%",
    gradientTransform: "translate(0.937705,0.453726),scale(0.665475,1.000000),rotate(73.739795),translate(-0.937705,-0.453726)",
    id: "radialGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1-SignIn/SignUp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edge-browser-icon",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4376453,58.0630525 C69.3913169,58.6068021 68.3123165,59.0852268 67.2068403,59.4955793 C63.7064468,60.7984464 59.9997506,61.4592501 56.2647742,61.446254 C41.8480688,61.446254 29.2906002,51.5404839 29.2906002,38.8001395 C29.3287499,35.3264642 31.2403543,32.1443423 34.2892042,30.4792927 C21.244067,31.0279199 17.8913448,44.6216844 17.8913448,52.5767798 C17.8913448,75.1314564 38.6477431,77.386924 43.1281991,77.386924 C45.5360632,77.386924 49.163099,76.6859003 51.3576081,75.9848766 L51.7538389,75.8629594 C60.1521023,72.9606432 67.3115327,67.2846984 72.0530478,59.7698929 C72.3362803,59.300604 72.2715049,58.69999 71.8947247,58.3018826 C71.5179446,57.9037753 70.9218027,57.8060616 70.4376453,58.0630525 L70.4376453,58.0630525 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4376453,58.0630525 C69.3913169,58.6068021 68.3123165,59.0852268 67.2068403,59.4955793 C63.7064468,60.7984464 59.9997506,61.4592501 56.2647742,61.446254 C41.8480688,61.446254 29.2906002,51.5404839 29.2906002,38.8001395 C29.3287499,35.3264642 31.2403543,32.1443423 34.2892042,30.4792927 C21.244067,31.0279199 17.8913448,44.6216844 17.8913448,52.5767798 C17.8913448,75.1314564 38.6477431,77.386924 43.1281991,77.386924 C45.5360632,77.386924 49.163099,76.6859003 51.3576081,75.9848766 L51.7538389,75.8629594 C60.1521023,72.9606432 67.3115327,67.2846984 72.0530478,59.7698929 C72.3362803,59.300604 72.2715049,58.69999 71.8947247,58.3018826 C71.5179446,57.9037753 70.9218027,57.8060616 70.4376453,58.0630525 L70.4376453,58.0630525 Z",
    id: "Path",
    fill: "url(#radialGradient-2)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2166123,73.5465332 C29.5035952,71.8614953 27.1519143,69.654852 25.2978129,67.0544438 C21.0119302,61.1881863 19.5386607,53.7273006 21.2730273,46.6722499 C23.007394,39.6171993 27.771955,33.6897803 34.2892042,30.4792927 C35.2645416,30.0221033 36.8799441,29.2296417 39.0439739,29.2601209 C42.1308112,29.2840043 45.0288977,30.7499625 46.8771521,33.222429 C48.103512,34.8716155 48.7757497,36.8669878 48.7973475,38.9220567 C48.7973475,38.8610981 56.2647742,14.6605398 24.4139134,14.6605398 C11.0335039,14.6605398 0.0304792927,27.3399255 0.0304792927,38.4953466 C-0.0227420323,44.3880712 1.23708646,50.2186824 3.7184737,55.5637505 C12.1300127,73.4750106 32.618737,82.2521495 51.3880874,75.9848766 C44.9586453,78.0155066 37.9620976,77.1242267 32.2470916,73.5465332 L32.2166123,73.5465332 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2166123,73.5465332 C29.5035952,71.8614953 27.1519143,69.654852 25.2978129,67.0544438 C21.0119302,61.1881863 19.5386607,53.7273006 21.2730273,46.6722499 C23.007394,39.6171993 27.771955,33.6897803 34.2892042,30.4792927 C35.2645416,30.0221033 36.8799441,29.2296417 39.0439739,29.2601209 C42.1308112,29.2840043 45.0288977,30.7499625 46.8771521,33.222429 C48.103512,34.8716155 48.7757497,36.8669878 48.7973475,38.9220567 C48.7973475,38.8610981 56.2647742,14.6605398 24.4139134,14.6605398 C11.0335039,14.6605398 0.0304792927,27.3399255 0.0304792927,38.4953466 C-0.0227420323,44.3880712 1.23708646,50.2186824 3.7184737,55.5637505 C12.1300127,73.4750106 32.618737,82.2521495 51.3880874,75.9848766 C44.9586453,78.0155066 37.9620976,77.1242267 32.2470916,73.5465332 L32.2166123,73.5465332 Z",
    id: "Path",
    fill: "url(#radialGradient-4)",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.450442,45.3531875 C46.1761284,45.6579804 45.414146,46.1151698 45.414146,47.0600279 C45.414146,47.8524895 45.932294,48.6449511 46.8771521,49.2850162 C51.2356909,52.3329455 59.4955793,51.9062354 59.5260585,51.9062354 C62.7753151,51.9040945 65.9645249,51.0304825 68.7612842,49.3764541 C74.4905725,46.0253488 78.0162148,39.8902673 78.0269892,33.2529083 C78.1184271,26.4255467 75.5886458,21.8841321 74.5828291,19.8724988 C68.0907398,7.25407165 54.161703,0 39.0134946,0 C17.679383,-0.0021095548 0.300010842,17.1328652 0,38.4648673 C0.152396463,27.3399255 11.2163797,18.3485342 24.3834341,18.3485342 C25.4502094,18.3485342 31.5460679,18.4399721 37.184737,21.3964634 C41.1461682,23.3649774 44.4266778,26.4756225 46.6028385,30.3268962 C48.4620753,33.5577012 48.7973475,37.6724057 48.7973475,39.3182875 C48.7973475,40.9641693 47.9744066,43.3720334 46.4199627,45.3836668 L46.450442,45.3531875 Z",
    id: "Path",
    fill: "url(#radialGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.450442,45.3531875 C46.1761284,45.6579804 45.414146,46.1151698 45.414146,47.0600279 C45.414146,47.8524895 45.932294,48.6449511 46.8771521,49.2850162 C51.2356909,52.3329455 59.4955793,51.9062354 59.5260585,51.9062354 C62.7753151,51.9040945 65.9645249,51.0304825 68.7612842,49.3764541 C74.4905725,46.0253488 78.0162148,39.8902673 78.0269892,33.2529083 C78.1184271,26.4255467 75.5886458,21.8841321 74.5828291,19.8724988 C68.0907398,7.25407165 54.161703,0 39.0134946,0 C17.679383,-0.0021095548 0.300010842,17.1328652 0,38.4648673 C0.152396463,27.3399255 11.2163797,18.3485342 24.3834341,18.3485342 C25.4502094,18.3485342 31.5460679,18.4399721 37.184737,21.3964634 C41.1461682,23.3649774 44.4266778,26.4756225 46.6028385,30.3268962 C48.4620753,33.5577012 48.7973475,37.6724057 48.7973475,39.3182875 C48.7973475,40.9641693 47.9744066,43.3720334 46.4199627,45.3836668 L46.450442,45.3531875 Z",
    id: "Path",
    fill: "url(#radialGradient-6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeBrowser);
export default __webpack_public_path__ + "static/media/edge-browser.8ad6383fba2df49731df12581301e08c.svg";
export { ForwardRef as ReactComponent };